<template>
  <tr @click="toggleSelf" style="cursor: pointer">
    <td style="padding-left: 90px">
      {{ data.name }}
      <span class="glyphicon is-aligned-right" :class="data.is_open ? ' glyphicon-collapse-up' : ' glyphicon-collapse-down'"></span>
    </td>
    <td>{{ usNum(data.app_goal)}}</td>
    <td>{{ usNum(data.apps)}}</td>
    <td></td>
    <td>{{ money(data.spend)}}</td>
    <td>{{ percent(data.percentage) }}</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
</template>

<script>
export default {
  props: [
    'data'
  ],
  data() {
    return {
    };
  },
  methods: {
    toggleSelf() {
      this.data.is_open = !this.data.is_open;
    }
  }
}
</script>

<style>
</style>
